import { loader } from 'graphql.macro'

export const SUBSCRIPTION_MY_CLASSES = loader('./myClasses.graphql')

export const SUBSCRIPTION_FAVORITE_CLASSES = loader('./favoriteClasses.graphql')

export const SUBSCRIPTION_STUDIO_TEACHERS = loader('./studioTeachers.graphql')
